// Framework
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
// Classes
import { Organization } from "@src/app/modules/share/classes/organization.class";
// Global
import { backendURL } from "@src/app/global";
// Services
import { DataApiService } from "@src/app/modules/share/services/templates/data-api.service";

@Injectable({
    providedIn: "root"
})
export class OrganizationApiService extends DataApiService<Organization> {
    private dummyData: Organization[] = [
        new Organization({
            id: "1",
            usaagoOrganizationName: "Organization 1",
        }),
        new Organization({
            id: "2",
            usaagoOrganizationName: "Organization 2",
        }),
        new Organization({
            id: "3",
            usaagoOrganizationName: "Organization 4",
        }),
        new Organization({
            id: "4",
            usaagoOrganizationName: "Organization 4",
        }),
    ];

    constructor(protected http: HttpClient) {
        super(backendURL + "organizations/", http, Organization);
    }

    getAllOrganizations(): Observable<Organization[]> {
        return this.getAll();
        // return of(this.dummyData);
    }
}
